export default __webpack_public_path__ + "static/media/yidongsudu.a76541a1.png";